// custom-input-text.js
import React from "react"
import PropTypes from "prop-types"
import { TextField, Grid, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(2),
    width: "100%",
  },
  labelRow: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "flex-start",
      marginBottom: theme.spacing(1),
    },
  },
  labelColumn: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: theme.spacing(1),
  },
  input: {
    width: "100%",
  },
  inputContainer: {
    width: "100%",
  },
  errorText: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(0.5),
  },
  asterisk: {
    color: "red",
    marginRight: theme.spacing(0.5),
  },
}))

const CustomInputText = ({
  label,
  value,
  onChange,
  hasError,
  errorMessage,
  required = false,
  direction = "row",
  ...props
}) => {
  const classes = useStyles()

  // Handle change event
  const handleChange = (e) => {
    e.preventDefault()
    onChange(e.target.value)
  }

  const isColumn = direction === "column"

  return (
    <Grid
      container
      spacing={2}
      className={classes.container}
      alignItems={isColumn ? "flex-start" : "center"}
      direction={isColumn ? "column" : "row"}
    >
      <Grid
        item
        xs={12}
        sm={isColumn ? 12 : 3}
        className={isColumn ? classes.labelColumn : classes.labelRow}
      >
        {required && <span className={classes.asterisk}>*</span>}
        <Typography variant="body1">{label}</Typography>
      </Grid>
      <Grid item xs={12} sm={isColumn ? 12 : 9} className={classes.inputContainer}>
        <TextField
          variant="outlined"
          value={value}
          onChange={handleChange}
          error={Boolean(hasError)}
          helperText={hasError ? errorMessage : ""}
          className={classes.input}
          fullWidth
          {...props}
        />
      </Grid>
    </Grid>
  )
}

CustomInputText.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  direction: PropTypes.oneOf(["row", "column"]),
}

CustomInputText.defaultProps = {
  hasError: false,
  errorMessage: "",
  required: false,
  direction: "row",
}

export default CustomInputText
